var map = {
	"./active-status-icon.svg": 349,
	"./articles-icon.svg": 5940,
	"./btn-back-arrow.svg": 8014,
	"./btn-white-arrow.svg": 1713,
	"./categories-icon.svg": 6985,
	"./checked-circle.svg": 5672,
	"./checked-white.svg": 1670,
	"./circled-cross.svg": 5554,
	"./circled-exclamation.svg": 994,
	"./circled-question-mark.svg": 6522,
	"./companies-static-icon.svg": 9917,
	"./contact-static-icon.svg": 4534,
	"./conversation-static-icon.svg": 4382,
	"./details-big-arrow.svg": 648,
	"./failed-status-icon.png": 4086,
	"./folder-icon.svg": 4365,
	"./green-arrow.svg": 3879,
	"./green-solid-right-arrow.svg": 1497,
	"./group-static-icon.svg": 6851,
	"./home-body-image.png": 8706,
	"./knowledge-static-icon.svg": 1335,
	"./login-sidebar-image.png": 5114,
	"./logo.svg": 2835,
	"./migrate-sidebar-background.svg": 5832,
	"./select-app-sidebar-image.png": 7955,
	"./setting-sidebar-background.svg": 80,
	"./setting-sidebar-image.png": 418,
	"./sidebar-login-background.svg": 2583,
	"./simple-blue-circle.svg": 6751,
	"./solo-member.svg": 7410,
	"./static-active-arrow.svg": 109,
	"./successfull-status-icon.svg": 1551,
	"./team.svg": 7828,
	"./ticket-static-icon.svg": 106,
	"./transparent-arrow.svg": 4186,
	"./vendor-card-desk-com.svg": 2107,
	"./vendor-card-freshdesk.svg": 2465,
	"./vendor-card-zendesk.svg": 8198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;